import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import BaiduMap from 'vue-baidu-map'
import Calendar from 'vue-mobile-calendar'
import "./css/font.css"
Vue.use(Calendar);
Vue.use(BaiduMap, {
  ak: 'BykTvGO0ZNkaRRwaLV6V0cnxVv6DWPH8' //官方提供的ak秘钥
});
Vue.use(ElementUI);

Vue.config.productionTip = false
// Vue.use(ElementUI)

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js